module.exports = __webpack_public_path__ + "img/2.9ad32b81.jpeg";